import ZkUserSaveOrUpdate from './src/main'
ZkUserSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkUserSaveOrUpdate.name, ZkUserSaveOrUpdate)
}
export default ZkUserSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/userSaveOrUpdate/index.js